import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=1e4a6892&scoped=true"
import script from "./AdminMenu.vue?vue&type=script&lang=js"
export * from "./AdminMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminMenu.vue?vue&type=style&index=0&id=1e4a6892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a6892",
  null
  
)

export default component.exports